import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PinchZoomModule } from '@meddv/ngx-pinch-zoom';

@Component({
  selector: 'app-photo-zoom',
  standalone: true,
  imports: [CommonModule, PinchZoomModule],
  template: `
    <pinch-zoom [auto-zoom-out]="true" [limit-zoom]="10" [transition-duration]="200">
        <img [src]="fullImage" alt="Zoomable photo" />
    </pinch-zoom>
`,
  styles: [`
    :host {
      display: block;
      max-width: 100%;
    }
    /* Ensure pinch-zoom image fills parent showing full photo height*/
    pinch-zoom {
        height: 100%;
        background-color: inherit !important; /* background white when aspect ration doesn't exactly fit container */
        img {
            width: auto;
            height: 100%;
            object-fit: contain;
        }
    }
  `]
})
export class PhotoZoomComponent implements OnInit {
  @Input() fullImage!: string;

  ngOnInit() {}
}
